import {
  SET_GRN_LOADING,
  SET_GRNS,
  SET_TOTAL_GRNS,
  SET_TOTAL_GRN_PAGES,
  SET_GRN_DATE,
  SET_GRN_SUPPLIER_CODE,
  SET_GRN_PO_NUMBER,
  SET_GRN_IR_NUMBER,
  SET_GRN_SUPPLIER_INVOICE_NUMBER,
  SET_GRN_PRODUCTS,
  CLEAR_NEW_GRN,
  LOAD_GRN_FOR_EDIT,
} from "../actions/grn"

const initialState = {
  grns: [],
  totalGRNs: 0,
  totalPages: 0,
  isLoading: false,
  newGRN: {
    date: null,
    supplierCode: "",
    poNumber: "",
    irNumber: "",
    supplierInvoiceNumber: "",
    products: [],
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_GRN_LOADING:
      return {
        ...state,
        isLoading: action.data,
      }

    case SET_GRNS:
      return {
        ...state,
        grns: action.data,
      }

    case SET_TOTAL_GRNS:
      return {
        ...state,
        totalGRNs: action.data,
      }

    case SET_TOTAL_GRN_PAGES:
      return {
        ...state,
        totalPages: action.data,
      }

    case SET_GRN_DATE:
      return {
        ...state,
        newGRN: {
          ...state.newGRN,
          date: action.data,
        },
      }

    case SET_GRN_SUPPLIER_CODE:
      return {
        ...state,
        newGRN: {
          ...state.newGRN,
          supplierCode: action.data,
        },
      }

    case SET_GRN_PO_NUMBER:
      return {
        ...state,
        newGRN: {
          ...state.newGRN,
          poNumber: action.data,
        },
      }

    case SET_GRN_IR_NUMBER:
      return {
        ...state,
        newGRN: {
          ...state.newGRN,
          irNumber: action.data,
        },
      }

    case SET_GRN_SUPPLIER_INVOICE_NUMBER:
      return {
        ...state,
        newGRN: {
          ...state.newGRN,
          supplierInvoiceNumber: action.data,
        },
      }

    case SET_GRN_PRODUCTS:
      return {
        ...state,
        newGRN: {
          ...state.newGRN,
          products: action.data,
        },
      }

    case CLEAR_NEW_GRN:
      return {
        ...state,
        newGRN: {
          date: null,
          supplierCode: "",
          poNumber: "",
          irNumber: "",
          supplierInvoiceNumber: "",
          products: [],
        },
      }

    case LOAD_GRN_FOR_EDIT:
      return {
        ...state,
        newGRN: {
          ...action.data,
        },
      }

    default:
      return state
  }
}
